module.exports = __webpack_public_path__ + "static/media/menu-digitale.47da9e3e.png";